import 'magnific-popup'

export default {
    init() {


        const $lostPasswordModalOpen = $('.lostpassword-modal-open')


		$lostPasswordModalOpen.on('click', function() {
			openlostPasswordModal()
		})


        // Function to open the modal
		function openlostPasswordModal() {
			$.magnificPopup.open({
				items: {
					src: '#lostpassword-modal'
				},
				type: 'inline',
				preloader: false,
				modal: true,
				callbacks: {
                    close: function() {

					},
					open: function() {

					},
				}
			})
		}



        $('#lost-password-form').on('submit', function(e) {
            e.preventDefault()

            const this_form = $(this)
            const submit_button = this_form.find('input[type="submit"]')
            const lost_pass_status = this_form.find('.lost-pass-status')

            lost_pass_status.removeClass('success error').show().text('Pošiljam podatke uporabnika...')
            submit_button.prop('disabled', true)

            $.post(my_ajax_object.ajax_url, { action: 'lost_password_nonce' }, function(nonce) {
                $.ajax({
                    url: my_ajax_object.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'lost_password',
                        username_email: $('#list_username_email').val(),
                        'security-lost': nonce
                    },
                    success: function(response) {
                        lost_pass_status.show().text(response.data.message)
                        if (response.success) {
                            lost_pass_status.addClass('success')
                            this_form[0].reset()
                        } else {
                            lost_pass_status.addClass('error')
                        }
                        submit_button.prop('disabled', false)
                    },
                    error: function() {
                        alert('Prišlo je do napake. Poskusite ponovno.')
                        submit_button.prop('disabled', false)
                    }
                })
            })
        })
    },
}
